import BlogPageLayout from "../BlogPageLayout"
import CapitulosPreview from "./CapitulosPreview"


const InicioLibro = () => {


    return (
        <BlogPageLayout
            titulo="Cómo mejorar tu dinero sin descuidar tu salud física"
            autor="Adrian Ayala"
            fecha="12 de marzo de 2026"
            articulo='true'
        >
            <div className="container-fluid">
                <div className="row d-flex justify-content-center">
                    <article className="col-10 col-md-8 inicio-title inicio-text-parrafo">
                        <h3>Introducción</h3>
                        <div style={{ textAlign: 'justify' }} className="">
                            <p className="fw-bold">Cuando el cuerpo cobra las deudas que el dinero no pudo pagar</p> <br />
                            <p>Este libro nace de una idea simple, pero poderosa:</p>
                            <p className="fw-bold">no se puede tener salud física sin salud financiera, ni salud financiera sin cuidar el cuerpo.</p>
                            <p>
                                Cuando el dinero se maneja mal, el cuerpo lo resiente. <br />
                                Cuando el cuerpo está descuidado, las finanzas se deterioran. <br />
                                Es un círculo que puede enfermarte… o sanarte.
                            </p> <br />
                            <p className="fw-bold">El verdadero costo de vivir estresado</p>
                            <p>
                                Muchas personas no necesitan ganar más; necesitan <b>orden, claridad y hábitos
                                    sostenibles.</b> Necesitan entender que cuidar el dinero no es tacañería y cuidar el
                                cuerpo no es un lujo. Ambos son actos de responsabilidad personal.
                            </p>
                            <p>
                                Este libro no busca decirte que renuncies a todo lo que disfrutas ni que te
                                conviertas en un experto financiero o en un atleta. Está escrito para personas
                                reales, con jornadas largas, responsabilidades, cansancio y poco tiempo, pero con
                                el deseo genuino de vivir mejor.
                            </p><br />
                            <p className="fw-bold">Cómo está organizado este libro</p>
                            <p>
                                El libro está dividido en cuatro partes. No necesitas leerlo de corrido, aunque
                                puedes hacerlo si así lo deseas.
                            </p>
                            <ul>
                                <li>
                                    En la <b>primera parte</b>, tomarás conciencia de cómo el desorden financiero y
                                    los malos hábitos físicos afectan tu vida diaria.
                                </li>
                                <li>
                                    En la <b>segunda parte</b>, aprenderás los fundamentos de la salud financiera
                                    usando sistemas del cuerpo humano como metáfora.
                                </li>
                                <li>
                                    En la <b>tercera parte</b>, encontrarás recomendaciones prácticas de salud física
                                    pensadas para personas trabajadoras.
                                </li>
                                <li>
                                    En la <b>cuarta parte</b>, aplicarás todo en un plan de acción claro y sencillo.
                                </li>
                            </ul>
                            <p>
                                Cada capítulo es corto y termina con ideas clave y acciones concretas, porque el
                                cambio no ocurre al leer, sino al aplicar.
                            </p>

                        </div>


                        <CapitulosPreview />
                    </article>
                </div>
            </div>

        </BlogPageLayout>
    )
}

export default InicioLibro